import LongArrowImage from 'assets/icons/longArrow.svg'
import BottleAnimation from 'assets/images/home/bottle.gif'
import FromToImage from 'assets/images/home/fromto.svg'
import HeroVideoImage from 'assets/images/home/HeroVideo.svg'
import ListAnimation from 'assets/images/home/list.gif'
import LoopAnimation from 'assets/images/home/loop.gif'
import RocketAnimation from 'assets/images/home/rocket.gif'
import { VideoPlayer } from 'components/Video/VideoPlayer'
import { FromTo, fromToData } from 'constants/HomeConstants'

export const Welcome = () => {
  const videoUrl =
    'https://facade-api-tccc-dev-stage.playground-stage.coke.com/api/file-manager/v1/tenants/571f9aa5-bb8b-4f9f-8835-23e74b64e050/files/2dd5ea0f-8708-4c06-b645-7a3e9023f523/public-download'

  return (
    <>
      <div className="flex flex-col lg:flex-row lg:justify-center gap-16 lg:gap-16 pt-16 mx-auto">
        <div className="w-full max-w-[496px] mx-auto lg:mx-0 self-center">
          {/* Thumbnail Image */}
          <VideoPlayer thumbnail={HeroVideoImage} url={videoUrl} />
        </div>
        <section className="w-full">
          <p className="title-xxs mb-4">
            Welcome to BVA! The Brand Vision Architecture framework is designed in a strategic way to describe how your
            brand reflects the brand purpose, value and positioning, to align teams worldwide around a clear brand
            narrative.
          </p>

          <p className="mb-4 body-s">
            This comprehensive guide provides step-by-step instructions, templates, and best practices for conducting{' '}
            <span className="font-bold">Brand Vision Architecture</span> refreshes and redo's.
          </p>

          <p className="mb-4 body-s">
            It serves as your practical handbook for implementing the new BVA framework, which has been enhanced to
            strengthen brand positioning through increased focus on Human Insights, Product Edge, and Data-Driven
            Decision Making.
          </p>

          <p className="body-s">
            The framework, templates, and exercises provided in this guide represent our standard approach to BVA
            development. They are designed to be robust enough to maintain the structural integrity that makes our BVAs
            powerful and actionable, but flexible enough to accommodate brand-specific nuances.
          </p>
        </section>
      </div>

      <div className=" mx-auto">
        <p className="text-center title-xl pt-20 pb-16">BVA 2.0: Framework Evolved</p>

        <div className="flex flex-wrap justify-center gap-8 pb-10 lg:pb-16 lg:flex-nowrap lg:justify-between">
          {[
            {
              bg: 'bg-[#FF8A7A]',
              img: LoopAnimation,
              text: 'Evolve current BVA into a standardized framework used across the network.',
            },
            { bg: 'bg-[#91DDA4]', img: ListAnimation, text: 'Discipline/rigor on data to influence inputs.' },
            { bg: 'bg-[#FEDEA8]', img: BottleAnimation, text: 'Strong focus on brand, consumer and product.' },
            {
              bg: 'bg-[#9FE3E7]',
              img: RocketAnimation,
              text: 'Simple yet complete process to guide marketers and serve as a repository.',
            },
          ].map((item, index) => (
            <div key={index} className="flex flex-col justify-center items-center w-full max-w-[262px] sm:w-[262px]">
              <div
                className={`${item.bg} w-[72px] h-[72px] mb-4 p-4 rounded-tl-[64px] rounded-tr-[64px] rounded-br-[64px]`}
              >
                <img src={item.img} alt="" className="w-10 h-10" />
              </div>
              <p className="body-s text-center">{item.text}</p>
            </div>
          ))}
        </div>

        <div className="flex flex-col lg:flex-row h-auto lg:h-[260px] rounded-[24px] border-neutral-30-width-l">
          <img
            src={FromToImage}
            alt=""
            className="w-full lg:w-auto lg:h-full rounded-t-14 lg:rounded-l-14 lg:rounded-tr-none"
          />
          <div className="flex flex-col sm:flex-row justify-between gap-8 sm:gap-4 lg:h-full w-full py-6 lg:py-10 px-6 lg:px-16 rounded-b-14 lg:rounded-r-14 lg:rounded-bl-none bg-gradient-surface-tint">
            {fromToData.map((item: FromTo, index: number) => (
              <div key={index} className="flex flex-col">
                <p className="subtitle-xxs mb-2">FROM</p>
                <p className="body-s">{item.from}</p>
                <img src={LongArrowImage} alt="Long arrow" className="h-10 my-6 self-baseline" />
                <p className="subtitle-xxs mb-2">TO</p>
                <p className="body-s">{item.to}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </>
  )
}
